import { ToggleButton, useTheme } from "@mui/material";
import { useStore } from "zustand";
import type { ToolClass } from "@designboticteam/workspace-3d";
import type { Workspace3DApi } from "../../types";

type Props<T extends ToolClass> = {
	store: Workspace3DApi["workspace3D"]["store"];
	setActiveTool: (tool: T | null) => void;
	tool: T;
	label: string;
	isDisabled?: boolean;
};

const ToolControl = <T extends ToolClass>({ store, setActiveTool, tool, label, isDisabled = false }: Props<T>): React.ReactNode => {
	const theme = useTheme();
	const activeTool = useStore(store, (state) => state.tools.activeTool);
	const isSelected = activeTool === tool.toolName;

	return (
		<ToggleButton
			disableRipple
			value={tool.toolName}
			size="small"
			color="mono"
			sx={{
				boxShadow: theme.shadows[1],
				textTransform: "none",
			}}
			disabled={isDisabled}
			selected={isSelected}
			onChange={() => setActiveTool(isSelected ? null : tool)}
		>
			{label}
		</ToggleButton>
	);
};

export { ToolControl };
